import { CLASS_NAMES, SCALE } from "../../utils/constants";
import UI from "../UI";
import Explosion from "./Explosion";
import Fallable from "./Fallable";
import Player from "./Player";

export default class Jewel extends Fallable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: false,
      isPickable: true,
      isCrushable: false,
      level,
    });
    this.strength = 4;
  }
  overrunBy(el) {
    if (el.isClass(Player)) {
      this.alien.destroy()
      this.shine.destroy()
      // this.alien.visible = false;
      // this.shine.visible = false;
      this.level.onJewelPick(this);
      this.level.scene.events.emit("sounds:gem_pick");
    }

    if (el.isClass(Explosion)) {
      this.alien.destroy()
      this.shine.destroy()
      // this.alien.visible = false;
      // this.shine.visible = false;
      this.alien.destroy();
    }
  }
  move(coords) {
    super.move(coords);
    if (!this.shine) {
      this.shine = this.level.scene.add
        .sprite(48, 16)
        .setOrigin(0.05, 0.2)
        .play("diamond_shine");
      this.shine.setScale(SCALE());
      this.shine.depth = 4.5
    }
    this.shine.x = UI.tileToScreen(coords.x);
    this.shine.y = UI.tileToScreen(coords.y);
    if(this.isFalling) {
      this.shine.stop()
    } else {
      this.shine.play("diamond_shine")
    }
  }
}

Jewel.className = CLASS_NAMES.JEWEL;
